<ng-container *transloco="let t; prefix: 'experience'">
  <div class="self-explore-map">
    <section #map class="map"></section>
    <button (click)="openSelfExploreModal()" class="ess-btn" type="button">{{ t('clickToExplore') }}</button>
    <section class="related-experiences">
      @for (relatedExperience of relatedExperiences; track relatedExperience; let i = $index) {
        <div class="related-experience">
          <div class="num">
            <img
              alt="{{ t('imageNumber', {imageNumber: i + 1}) }}"
              src="{{ NUMBER_URL }}{{ i + 1 | number: '2.0' }}.svg"
            />
          </div>
          <div class="content">
            <h3 class="heading-s"
              ><strong>{{ relatedExperience.subcategory }}</strong></h3
            >
            <h4 class="heading-xl">{{ relatedExperience.title }}</h4>
          </div>
        </div>
      }
    </section>
  </div>
</ng-container>
